<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs10 offset-xs1>
        <v-progress-circular
          :size="70"
          :width="7"
          color="pipefish"
          indeterminate
          v-show="!showAlert"
        ></v-progress-circular>
        <v-alert
          :value="showAlert"
          :type="alertType"
        >
          {{message}}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    showAlert: false,
    alertType: 'warning',
    approval_id: '',
    secret: '',
    message: ''
  }),
  created() {
    this.approval_id = this.$route.params.approval_id
    this.secret = this.$route.params.secret
    if(this.$route.params.type == "approve") {
      this.approve()
    } else {
      this.reject()
    }
  },
  methods: {
    approve() {
      var self = this
      this.$timesheetApi.approveTimesheets({
          approval_id: this.approval_id,
          secret: this.secret,
          ApprovedOn: new Date()
        }).then(response => {
          self.message = response
          self.alertType = 'success'
          self.showAlert = true
        }).catch(err => {
          self.message = err.response.data
          self.alertType = 'error'
          self.showAlert = true
        })
    },
    reject() {
      var self = this
      this.$timesheetApi.rejectTimesheets({
        approval_id: this.approval_id,
        secret: this.secret
      }).then(response => {
        self.alertType = 'warning'
        self.message = response
        self.showAlert = true
      }).catch(err => {
        self.message = err.response.data
        self.alertType = 'error'
        self.showAlert = true
      })
      
    },
  }

}
</script>

<style>

</style>
